<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {
  components: {
    BootstrapTable
  },
  data () {
    return {
      columns: [
        {
          field: 'first_name',
          title: 'First Name'
        },
        {
          field: 'last_name',
          title: 'Last Name'
        },
        {
          field: 'email',
          title: 'Email'
        },
        {
          field: 'tools',
          title: 'Tools',
          formatter: function(value, row, index){
            return [
                ' <a class="table-control btn btn-outline-primary btn-sm" href="/account/user/edit/'+row.id+'" title="Edit Account">',
                '<i class="fa fa-key"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-secondary btn-sm" href="/profile/user/edit/'+row.id+'" title="Edit Profile">',
                '<i class="fa fa-address-card-o"></i>',
                '</a>'
              ].join('');
          },
          width: 130,
          align: 'center'
        }
      ],
      data: '/account/users/list',
      options: {
        search: true,
      }
    }
  }
}




</script>